import FilteredListings from './FilteredListings'

export default FilteredListings
